import Main from './lower/main';

const main = new Main();

